import TYPES from '@/types';
import Vue from 'vue';

// Domain
import Inject from '@/modules/shared/domain/di/inject';
import Translator from '@/modules/shared/domain/i18n/translator';
import { Values } from '@/modules/shared/domain/i18n/types';

export default class StrategyModerateWarningChangeStrategyViewModel {
  @Inject(TYPES.I18N)
  private readonly translator!: Translator;

  readonly view: Vue;

  readonly i18n_namespace = 'components.strategy-moderate-wealth.strategy-moderate-warning-change-strategy';

  public constructor(view: Vue) {
    this.view = view;
  }

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  closeModal = () => {
    this.view.$emit('closeModal');
  }

  changeStrategy = () => {
    this.view.$emit('changeStrategy');
  }

  initialize = () => {
    this.setDynamicWidth();
  }

  setDynamicWidth = () => {
    this.view.$emit('setDynamicWidth', '35');
  }
}
